import { LoggingFacade, LogLevel, LogOutput } from '@/types/Logging';

/**
 * This is a facade for the inner logger
 * that hides the implementation of the logging
 * methods and offers a memory for the logging meta.
 * @param meta - metadata to initialize the logger with
 *
 * @example
 * getLogger({
 *   file: "src/main/main.ts",
 * })
 */
export const getWindowLogger = (meta: { file: string }): LoggingFacade => {
  const newLogger = {
    _file: 'no-filepath',
    get file() {
      return this._file;
    },
    set file(value: string) {
      this._file = value;
    },
    debug: (output: LogOutput) => {
      output.file = newLogger.file;
      window.logger?.log(LogLevel.DEBUG, output);
    },
    info: (output: LogOutput) => {
      output.file = newLogger.file;
      window.logger?.log(LogLevel.INFO, output);
    },
    warning: (output: LogOutput) => {
      output.file = newLogger.file;
      window.logger?.log(LogLevel.WARNING, output);
    },
    error: (output: LogOutput) => {
      output.file = newLogger.file;
      window.logger?.log(LogLevel.ERROR, output);
    },
  };
  newLogger.file = meta.file;
  return newLogger;
};
